import React from 'react';
import './styles/Tasks.css';

const Tasks = () => {
  return (
    <div className="tasks-container">
      <div className="tasks-header">
        <h1>Tasks</h1>
        <p className="tasks-subtitle">Campaign task management</p>
      </div>
      
      <div className="tasks-content">
        <div className="tasks-placeholder">
          <div className="placeholder-icon">📋</div>
          <h2>Coming Soon</h2>
          <p>Task management features will be available in a future update.</p>
          <p className="placeholder-description">
            Track campaign progress, set reminders, and manage your workflow all in one place.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Tasks;

